import awsEvent from './awsEvent';
export default awsEvent('Sns');